// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3yduE","list":"PatternAutocomplete_list__24QVI"};